/**
 * @file MenuLocationPanel.tsx
 * @description Пункты одного места меню с подсказками (phase19.16 Р1;
 * uiux-design-r1 §3 «Состояния и тексты»): пусто в шапке («Добавить
 * «Каталог» и «Блог»») или подвале, больше 7 пунктов наверху, подсказка
 * про перетаскивание и два уровня.
 */

import type { SiteMenuLocation } from "@chaiberi/shared";

import { Button } from "../../ui/button";
import { NoticeStrip } from "../../ui/NoticeStrip";
import type { RowAction } from "../../ui/RowActionsMenu";
import { MenuTree } from "./MenuTree";
import { MENU_TOP_SOFT_MAX } from "../../../lib/site-view/menu-link-types";
import type { SiteMenuItem } from "../../../lib/site-view/types";

interface Props {
  location: SiteMenuLocation;
  tree: SiteMenuItem[];
  columns: number;
  logoAfter: number | null;
  actionsFor: (item: SiteMenuItem, nested: boolean) => RowAction[];
  onReorder: (tree: SiteMenuItem[]) => void;
  onAddDefaults: () => void;
}

export function MenuLocationPanel({ location, tree, logoAfter, actionsFor, onReorder, onAddDefaults }: Props) {
  if (tree.length === 0) {
    return location === "HEADER" ? (
      <NoticeStrip action={<Button variant="outline" onClick={onAddDefaults}>Добавить «Каталог» и «Ленту блога»</Button>}>
        В шапке нет пунктов — покупатели увидят логотип, вход в кабинет и корзину.
      </NoticeStrip>
    ) : (
      <NoticeStrip>Меню подвала пустое — в подвале останутся контакты и сведения о продавце.</NoticeStrip>
    );
  }
  return (
    <>
      {location === "HEADER" && tree.length > MENU_TOP_SOFT_MAX ? (
        <NoticeStrip tone="warning">
          На ПК в строку помещается 6–7 пунктов, остальные уйдут в «Ещё». Проверьте в предпросмотре.
        </NoticeStrip>
      ) : null}
      <MenuTree items={tree} actionsFor={actionsFor} onReorder={onReorder} logoAfter={logoAfter} />
      <p className="type-caption text-on-surface-variant">
        Тяните за ⋮⋮, чтобы поменять порядок; вложить в пункт выше или вынести — через «⋯». Уровней не больше двух.
        {location === "FOOTER" ? " Колонки подвала — группы верхнего уровня." : ""}
      </p>
    </>
  );
}
